<template>
  <span :class="['v2-badge', `v2-badge--${variant}`]" :role="role">
    <slot name="icon" />
    <span class="v2-badge__label">{{ label }}</span>
  </span>
</template>

<script>
export default {
  name: "StatusBadge",
  props: {
    label: { type: [String, Number], required: true },
    variant: {
      type: String,
      default: "neutral",
      validator: (v) => ["success", "warning", "error", "info", "neutral"].includes(v),
    },
    role: { type: String, default: "status" },
  },
};
</script>

<style scoped>
.v2-badge {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  padding: var(--space-1) var(--space-3);
  font-size: var(--fs-label-sm);
  font-weight: var(--fw-semibold);
  border-radius: var(--radius-full);
  line-height: 1;
  white-space: nowrap;
}

.v2-badge__label {
  display: inline-block;
}

.v2-badge--success { background-color: var(--color-success-soft); color: var(--color-success); }
.v2-badge--warning { background-color: var(--color-warning-soft); color: var(--color-warning); }
.v2-badge--error   { background-color: var(--color-error-soft);   color: var(--color-error); }
.v2-badge--info    { background-color: var(--color-info-soft);    color: var(--color-info); }
.v2-badge--neutral { background-color: var(--color-neutral-100);  color: var(--color-neutral-700); }
</style>
